import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { StyledButton } from "./RadiusedButtonStyle";

const RadiusedButton = ({ value, isTransparent, hrefValue, onClick }) => {
  const { t } = useTranslation();
  return (
    <a rel="noreferrer" aria-label={value} onClick={onClick} target={"_blank"} href={hrefValue}>
      <StyledButton isTransparent={isTransparent}>{t(value)}</StyledButton>
    </a>
  );
};

RadiusedButton.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
};

export default RadiusedButton;
